import React from "react";

/**
 * Application footer. `login="true"` renders the light-on-dark variant used on
 * the sign-in panel; otherwise the slim in-app footer.
 */
export function FooterComponents(props) {
  const year = new Date().getFullYear();

  if (props.login === "true") {
    return (
      <footer className="text-center text-sm text-cyan-100/90">
        <p>© {year} HEC. Government of Rwanda</p>
        <p className="mt-1 text-cyan-200/70">All rights reserved</p>
      </footer>
    );
  }

  return (
    <footer className="mt-auto w-full border-t border-slate-200 bg-white/80 backdrop-blur-sm">
      <div className="px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500">
        <p>
          © {year} <span className="font-medium text-slate-700">Higher Education Council</span> · Government of Rwanda. All rights reserved.
        </p>
        <nav className="flex items-center gap-4">
          <a href="#" className="hover:text-cyan-700 transition-colors">
            Privacy Policy
          </a>
        </nav>
      </div>
    </footer>
  );
}
